<template>
   <div style="display: inline; float: right;">
    <b-button :href="'https://console.nutanix.com/#token=' + frameToken.token" target="_blank" variant="success" v-if="frameToken" class="my-3" @click="handleClick">Launch Virtual Desktop</b-button>
    <b-spinner variant="primary" label="Spinning" v-if="loading"></b-spinner>
  </div>
</template>

<script>
import Api from '@/api/Api'

export default {
  props: [ 'course' ],
  data () {
    return {
      showForm: false,
      loading: false,
      frameToken: null
    }
  },
  created () {
    var vm = this
    if (vm.loading) {
      return
    }
    vm.loading = true
    Api().post(`Frame/${vm.course.id}`)
      .then((r) => {
        vm.frameToken = r.data
      })
      .catch((e) => {
        console.log(e)
      })
      .finally(() => {
        vm.loading = false
      })
  },
  methods: {
    handleClick () {
      this.$emit('click')
    }
  }
}
</script>

<style>

</style>
